import React from 'react';
import { createStackNavigator } from '@react-navigation/stack';
import { HIDDEN_ALERTS_ROUTES } from './routes';
import { HiddenAlertsScreen } from '@/screens/insights-hub/hidden-alerts-screen';
import { HiddenAlertsStackParams } from './types';
import { useDefaultStackScreenOptions } from '@/hooks/use-default-stack-screen-options';

const Stack = createStackNavigator<HiddenAlertsStackParams>();

export const HiddenAlertsStack: React.FC = () => {
  const options = useDefaultStackScreenOptions();
  return (
    <Stack.Navigator screenOptions={options}>
      <Stack.Screen
        component={HiddenAlertsScreen}
        name={HIDDEN_ALERTS_ROUTES.Base}
      />
    </Stack.Navigator>
  );
};
